/** Defers an emission to a microtask so it runs AFTER the surrounding Y.Doc
 *  transaction (Y.applyUpdate) completes — prevents observer re-entrancy.
 *  See boundary/README.md, workaround 1. */
export function emitAfterTransaction(emit: () => void, onError: (err: unknown) => void): void {
    queueMicrotask(() => {
        try {
            emit();
        } catch (err) {
            onError(err);
        }
    });
}
